import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=unauth, object=authed
  const [branding, setBranding] = useState({
    business_name: "IGC Trust Portal",
    primary_color: "#1C252E",
    accent_color: "#C5A880",
    logo_url: "",
    header_image_url: "",
  });

  const loadBranding = useCallback(async () => {
    try {
      const { data } = await api.get("/branding");
      setBranding(data);
    } catch (e) { /* ignore */ }
  }, []);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    loadBranding();
  }, [refresh, loadBranding]);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      return { ok: true, user: data };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
    }
  };

  const register = async (name, email, password) => {
    try {
      const { data } = await api.post("/auth/register", { name, email, password });
      setUser(data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };

  const markTourSeen = () => {
    setUser((u) => (u && typeof u === "object" ? { ...u, has_seen_tour: true } : u));
  };

  return (
    <AuthContext.Provider value={{ user, branding, login, register, logout, refresh, refreshUser: refresh, setBranding, loadBranding, markTourSeen }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
